/**
 * @generated SignedSource<<19e28bb3104cc0272f0a096d8f576520>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedDealReleasesCountRange = "_0_0" | "_1_1" | "_2_2" | "_3_3" | "_4_inf";
export type FeaturedDealSpotifyMonthlyListenersRange = "_0_99999" | "_100000_749999" | "_2000000_inf" | "_750000_1999999";
export type FeaturedDealStreamsThisWeekRange = "_0_99999" | "_100000_749999" | "_2000000_inf" | "_750000_1999999";
export type FeaturedDealTiktokFollowersRange = "_0_9999" | "_100000_499999" | "_10000_99999" | "_500000_inf";
export type FeaturedDealTiktokPostsRange = "_0_2499" | "_10000_49999" | "_2500_9999" | "_50000_inf";
export type FeaturedDealDirectoryPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  genres?: ReadonlyArray<string | null> | null;
  onlyWatching?: boolean | null;
  orderBy?: string | null;
  releasesCount?: ReadonlyArray<FeaturedDealReleasesCountRange | null> | null;
  spotifyMonthlyListeners?: ReadonlyArray<FeaturedDealSpotifyMonthlyListenersRange | null> | null;
  streamsThisWeek?: ReadonlyArray<FeaturedDealStreamsThisWeekRange | null> | null;
  tiktokFollowers?: ReadonlyArray<FeaturedDealTiktokFollowersRange | null> | null;
  tiktokPosts?: ReadonlyArray<FeaturedDealTiktokPostsRange | null> | null;
};
export type FeaturedDealDirectoryPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeaturedDealDirectoryRows_availableFeaturedDeals">;
};
export type FeaturedDealDirectoryPaginationQuery = {
  response: FeaturedDealDirectoryPaginationQuery$data;
  variables: FeaturedDealDirectoryPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "genres"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "onlyWatching"
  },
  {
    "defaultValue": "-date",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "releasesCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spotifyMonthlyListeners"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamsThisWeek"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tiktokFollowers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tiktokPosts"
  }
],
v1 = {
  "kind": "Variable",
  "name": "genres",
  "variableName": "genres"
},
v2 = {
  "kind": "Variable",
  "name": "onlyWatching",
  "variableName": "onlyWatching"
},
v3 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v4 = {
  "kind": "Variable",
  "name": "releasesCount",
  "variableName": "releasesCount"
},
v5 = {
  "kind": "Variable",
  "name": "spotifyMonthlyListeners",
  "variableName": "spotifyMonthlyListeners"
},
v6 = {
  "kind": "Variable",
  "name": "streamsThisWeek",
  "variableName": "streamsThisWeek"
},
v7 = {
  "kind": "Variable",
  "name": "tiktokFollowers",
  "variableName": "tiktokFollowers"
},
v8 = {
  "kind": "Variable",
  "name": "tiktokPosts",
  "variableName": "tiktokPosts"
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentChange",
  "storageKey": null
},
v14 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v10/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = [
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "releaseType",
    "storageKey": null
  },
  (v10/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedDealDirectoryPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "FeaturedDealDirectoryRows_availableFeaturedDeals"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeaturedDealDirectoryPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "FeaturedDealNodeConnection",
        "kind": "LinkedField",
        "name": "availableFeaturedDeals",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeaturedDealNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watching",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editorialNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokSoundNodeConnection",
                    "kind": "LinkedField",
                    "name": "tiktokSounds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokSoundNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokSoundNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tiktokUrl",
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatWithDelta",
                                "kind": "LinkedField",
                                "name": "mostRecentStat",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previous",
                                    "storageKey": null
                                  },
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistNode",
                    "kind": "LinkedField",
                    "name": "artist",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActorInterface",
                        "abstractKey": "__isActorInterface"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatWithDelta",
                        "kind": "LinkedField",
                        "name": "latestSpotifyMonthlyListenerCount",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isWatchingCurrentUserCompany",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "spotifyProfile",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatWithDelta",
                        "kind": "LinkedField",
                        "name": "latestTiktokFollowerCount",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "tiktokProfile",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastApprovedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "soundLink",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNodeConnection",
                        "kind": "LinkedField",
                        "name": "releases",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNodeConnection",
                        "kind": "LinkedField",
                        "name": "unreleasedReleases",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArtistNode",
                        "kind": "LinkedField",
                        "name": "artist",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastActiveAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "actor",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v18/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProfileNode",
                                            "kind": "LinkedField",
                                            "name": "spotifyProfile",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ArtistNode",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ActorInterface",
                            "abstractKey": "__isActorInterface"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OfferFeaturedDealInterface",
                    "abstractKey": "__isOfferFeaturedDealInterface"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "filters": [
          "orderBy",
          "onlyWatching",
          "genres",
          "releasesCount",
          "streamsThisWeek",
          "spotifyMonthlyListeners",
          "tiktokPosts",
          "tiktokFollowers"
        ],
        "handle": "connection",
        "key": "FeaturedDealDirectory_availableFeaturedDeals",
        "kind": "LinkedHandle",
        "name": "availableFeaturedDeals"
      }
    ]
  },
  "params": {
    "cacheID": "ca380d6d126a13a66d193ae6a0130aff",
    "id": null,
    "metadata": {},
    "name": "FeaturedDealDirectoryPaginationQuery",
    "operationKind": "query",
    "text": "query FeaturedDealDirectoryPaginationQuery(\n  $count: Int = 25\n  $cursor: String\n  $genres: [ID]\n  $onlyWatching: Boolean = false\n  $orderBy: String = \"-date\"\n  $releasesCount: [FeaturedDealReleasesCountRange]\n  $spotifyMonthlyListeners: [FeaturedDealSpotifyMonthlyListenersRange]\n  $streamsThisWeek: [FeaturedDealStreamsThisWeekRange]\n  $tiktokFollowers: [FeaturedDealTiktokFollowersRange]\n  $tiktokPosts: [FeaturedDealTiktokPostsRange]\n) {\n  ...FeaturedDealDirectoryRows_availableFeaturedDeals_1FTAYm\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment FeaturedDealDirectoryRows_availableFeaturedDeals_1FTAYm on Query {\n  availableFeaturedDeals(first: $count, after: $cursor, orderBy: $orderBy, onlyWatching: $onlyWatching, genres: $genres, releasesCount: $releasesCount, streamsThisWeek: $streamsThisWeek, spotifyMonthlyListeners: $spotifyMonthlyListeners, tiktokPosts: $tiktokPosts, tiktokFollowers: $tiktokFollowers) {\n    edges {\n      node {\n        id\n        ...RowDeal_featuredDeal\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment OfferDealArtistReleases_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  artist {\n    displayName\n    isWatchingCurrentUserCompany\n    ...AvatarIcon_actor\n    id\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment RowDeal_dropdown on FeaturedDealNode {\n  id\n  watching\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n  artist {\n    ...useMessage_actor\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    id\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment RowDeal_featuredDeal on FeaturedDealNode {\n  ...RowDeal_dropdown\n  ...OfferDealArtistReleases_query\n  id\n  artist {\n    id\n    displayName\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    isWatchingCurrentUserCompany\n    spotifyProfile {\n      url\n      id\n    }\n    latestTiktokFollowerCount {\n      current\n      percentChange\n    }\n    tiktokProfile {\n      url\n      id\n    }\n  }\n  lastApprovedAt\n  watching\n  soundLink\n  editorialNote\n  tiktokSounds {\n    ...RowDeal_useTikTokSoundsTotal\n  }\n}\n\nfragment RowDeal_useTikTokSoundsTotal on TikTokSoundNodeConnection {\n  edges {\n    node {\n      tiktokUrl\n      name\n      mostRecentStat {\n        current\n        previous\n        percentChange\n      }\n      id\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "363459db76e4206a9e8596694287a6aa";

export default node;
